import { VerticalAlignTopOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Slider } from 'antd'
import { addDays, subDays } from 'date-fns'
import moment from 'moment/moment'
import type React from 'react'
import { useState } from 'react'

interface IProps {
  setCurrentFilters: ({}) => void
  fromKey: string
  toKey: string
  dayRangeStorage: any
  setDayRangeStorage: ({}) => void
  min: number
  max: number
  maxDateRange?: number
  defaultSliderValues?: [number, number]
}
export const DefaultSlider: React.FC<IProps> = ({
  setCurrentFilters,
  fromKey,
  toKey,
  dayRangeStorage,
  setDayRangeStorage,
  min,
  max,
  maxDateRange,
  defaultSliderValues,
}) => {
  const [sliderValues, setSliderValues] = useState([
    dayRangeStorage?.back !== undefined ? parseInt(dayRangeStorage.back) : (min ?? defaultSliderValues?.[0] ?? -3),
    dayRangeStorage?.ahead !== undefined
      ? parseInt(dayRangeStorage.ahead)
      : (maxDateRange ?? max ?? defaultSliderValues?.[1] ?? 1),
  ])

  const applyChanges = (setInStorage = true, values = sliderValues) => {
    if (setInStorage) {
      setDayRangeStorage({ back: values[0], ahead: values[1] })
    }

    setCurrentFilters((currentFilters) => ({
      ...currentFilters,
      [fromKey]: moment(addDays(new Date(), values[0])).startOf('day'),
      [toKey]: moment(addDays(new Date(), values[1])).endOf('day'),
    }))
  }

  const sliderChange = (value) => {
    if (value[0] === 0 && value[1] === 0) return
    setSliderValues(value)
  }

  const resetChanges = () => {
    if (defaultSliderValues) setSliderValues(defaultSliderValues)
    else if (min && max) setSliderValues([min, maxDateRange ?? max])
    else setSliderValues([-3, 1])
  }

  const setDefault = () => {
    if (defaultSliderValues) setSliderValues(defaultSliderValues)
    if (min && max) setSliderValues([min, maxDateRange ?? max])
    if (min > 0) setSliderValues([null, maxDateRange ?? max])
    else setSliderValues(defaultSliderValues ?? [-3, 1])
    applyChanges(false)
  }

  return (
    <Horizontal alignItems='flex-end' style={{ backgroundColor: '#E1EEFF', padding: '0 1em 1em' }}>
      <Vertical flex={3}>
        <GraviButton
          style={{
            border: 'none',
            backgroundColor: '#E1EEFF',

            maxWidth: 'fit-content',
            paddingLeft: 0,
          }}
          buttonText='DEFAULT WINDOW'
          icon={<VerticalAlignTopOutlined style={{ transform: 'rotate(-90deg)' }} />}
          onClick={setDefault}
        />
        <Texto>Use this setting to load a tailored grid view every time.</Texto>
      </Vertical>

      <Horizontal verticalCenter flex={4} horizontalCenter>
        <Texto className='mt-3' appearance='secondary' weight='bold'>
          <VerticalAlignTopOutlined className='mr-2' style={{ transform: 'rotate(-90deg)' }} />
          {sliderValues[0] === 0
            ? 'Today'
            : sliderValues[0] < 0
              ? `${Math.abs(sliderValues[0])} day${Math.abs(sliderValues[0]) > 1 ? 's' : ''} back`
              : `${Math.abs(sliderValues[0])} day${Math.abs(sliderValues[0]) > 1 ? 's' : ''} ahead`}
        </Texto>
        <Slider
          range
          className='date-range-filter-slider mx-4'
          defaultValue={sliderValues}
          value={sliderValues}
          min={min ?? -15}
          max={maxDateRange ?? max ?? 15}
          style={{ width: '200px', marginBottom: 0, marginTop: '1em' }}
          onChange={sliderChange}
        />
        <Texto className='mt-3' appearance='secondary' weight='bold'>
          <VerticalAlignTopOutlined className='mr-2' style={{ transform: 'rotate(90deg)' }} />
          {sliderValues[1] === 1 ? `${sliderValues[1]} day ahead` : `${sliderValues[1]} days ahead`}
        </Texto>
      </Horizontal>
      <Vertical alignItems='space-between' style={{ maxWidth: 'fit-content', padding: '1em 0.5em 0' }}>
        <GraviButton
          buttonText='Reset'
          theme4='true'
          style={{ maxWidth: 'fit-content', marginBottom: '0.5em', height: 'fit-content', padding: '2px 10px' }}
          onClick={resetChanges}
        />
        <GraviButton
          buttonText='Apply'
          theme2
          style={{ width: 'fit-content', height: 'fit-content', padding: '2px 10px' }}
          onClick={applyChanges}
        />
      </Vertical>
    </Horizontal>
  )
}
